function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("rect", {
  width: 56,
  height: 56,
  rx: 28,
  fill: "#40EBD5",
  fillOpacity: 0.1
});

var _ref3 =
/*#__PURE__*/
React.createElement("rect", {
  x: 8,
  y: 8,
  width: 40,
  height: 40,
  rx: 20,
  fill: "#40EBD5"
});

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#clip0_6805_238441)"
}, React.createElement("path", {
  d: "M21 28L26 33L36 23",
  stroke: "white",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var _ref5 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "clip0_6805_238441"
}, React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "white",
  transform: "translate(16 16)"
})));

var SvgConfirmIconDark = function SvgConfirmIconDark(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgConfirmIconDark, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ConfirmIcon_Dark.a0aa4418.svg";
export { ForwardRef as ReactComponent };